import { useContext } from 'react';
import { useParams } from '@tanstack/react-router';

import {
  ResizableHandle,
  ResizablePanel,
  ResizablePanelGroup,
} from '@/components/ui/resizable';
import { TraceDetails } from '@/routes/(app)/(tracing)/components/trace-details';
import { SpanDetail } from '@/routes/(app)/(tracing)/components/trace-span-details';
import { TracesTable } from '@/routes/(app)/(tracing)/components/traces-table';
import {
  TraceContext,
  TraceProvider,
} from '@/routes/(app)/(tracing)/context/trace-context';
import { useRefinedTraces } from '@/routes/(app)/(tracing)/hooks/use-refined-traces';

const InnerTracing = () => {
  const { componentName } = useParams({ from: '/app/tracing/$componentName' });
  const { traces, isLoading } = useRefinedTraces(componentName);
  const { isOpen: open } = useContext(TraceContext);

  return (
    <main>
      <ResizablePanelGroup direction='horizontal'>
        <ResizablePanel>
          <TracesTable
            traces={traces}
            isLoading={isLoading}
          />
        </ResizablePanel>
        {open && (
          <>
            <ResizableHandle withHandle />
            <ResizablePanel
              maxSize={50}
              minSize={10}>
              <TraceDetails />
            </ResizablePanel>
          </>
        )}
        {open && (
          <>
            <ResizableHandle withHandle />
            <ResizablePanel
              maxSize={50}
              minSize={10}>
              <SpanDetail />
            </ResizablePanel>
          </>
        )}
      </ResizablePanelGroup>
    </main>
  );
};

export const Tracing = () => (
  <TraceProvider>
    <InnerTracing />
  </TraceProvider>
);
